module.exports = __webpack_public_path__ + "media/images/vector-4@2x-e915160a32e62a86f1c16152dcb7b0e4.png";